import { connect } from 'react-redux';
import { setLangSelected } from '../../actions';
import { createNewConversation } from '../../actions/conversation';
import SetupAudio from './SetupAudio';
export default connect(null, {
    createNewConversation,
    setLangSelected,
})(SetupAudio);
